/**
 * Tooltip Component
 * hover / 키보드 focus 시 말풍선 표시 (CSS 로 토글)
 *
 * 사용:
 *   <Tooltip content="설명 문구">
 *     <button type="button" aria-label="설명 보기">…</button>
 *   </Tooltip>
 * - children 은 focus 가능한 요소(button 등)여야 키보드로도 열림
 */

import { useId } from 'react';

interface TooltipProps {
  content: React.ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  children: React.ReactNode;
}

export function Tooltip({ content, placement = 'bottom', children }: TooltipProps) {
  const id = useId();

  return (
    <span className={`tooltip tooltip-${placement}`} aria-describedby={id}>
      {children}
      <span role="tooltip" id={id} className="tooltip-bubble">
        {content}
      </span>
    </span>
  );
}

export default Tooltip;
